export default __webpack_public_path__ + "static/media/Dragon-Cake.0cfb96f1.jpg";